// removed by extract-text-webpack-plugin
module.exports = {"root":"LoginUpsell--root--12","heading":"LoginUpsell--heading--pF","children":"LoginUpsell--children--3H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginUpsell/styles.styl
// module id = 814
// module chunks = 0